import { ISuperBannerItem, LoginRestriction } from "../../../data/models";

export class LoginControlHelper {
    private static _instance: LoginControlHelper;

    public static get instance(): LoginControlHelper {
        if (!LoginControlHelper._instance) {
            LoginControlHelper._instance = new LoginControlHelper();
        }
        return LoginControlHelper._instance;
    }

    private validatorForLoginControl: {[loginControlId: number] : (isUserLoggedIn: boolean) => boolean} = {
        [LoginRestriction.All]:(isUserLoggedIn: boolean) => true,
        [LoginRestriction.LoggedInOnly]:(isUserLoggedIn: boolean) => isUserLoggedIn,
        [LoginRestriction.LoggedOutOnly]:(isUserLoggedIn: boolean) => !isUserLoggedIn
    };

    validate(item: ISuperBannerItem, isUserLoggedIn: boolean): boolean {
        return item.LoginControl
                ? this.validatorForLoginControl[item.LoginControl](isUserLoggedIn)
                : this.validatorForLoginControl[LoginRestriction.All](isUserLoggedIn);
    }
}